module.exports = __webpack_public_path__ + "img/front_9.b0d62589.svg";